#import "../fragments/filtered-quote-fragment.graphql"
query GetFilteredQuotes($input: QuotesSearchInput!) {
    quotes: quotesSearch(input: $input) {
        edges {
            node {
                ...FilteredQuoteFragment
            }
        }
        pageInfo {
            hasNextPage
            hasPreviousPage
            startCursor
            endCursor
        }
        totalCount
    }
}
